import React from 'react';
import { AddressContainer } from '../../../../common/address/containers/address.container';



export const MentorsAddressComponent = ({ onInnerFormChange,selectedAddress }: any) => (
          <>

                <AddressContainer
                    
                    onInnerFormChange={onInnerFormChange}
                    selectedAddress={selectedAddress}
                />
  
           
         
             
                
  
              

</>
)
export default MentorsAddressComponent;
